import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
};

export type AbilityChangeResult = {
  __typename?: 'AbilityChangeResult';
  heroBuild: Scalars['JSON']['output'];
  heroHandle: Scalars['String']['output'];
};

export type AttributeChangeResult = {
  __typename?: 'AttributeChangeResult';
  heroBuild: Scalars['JSON']['output'];
  heroHandle: Scalars['String']['output'];
};

export type CavernsMobDeathEventInput = {
  deathTileId: Scalars['String']['input'];
  livingHeroHandles: Array<Scalars['String']['input']>;
  mob_id: Scalars['String']['input'];
};

export type CavernsMobDeathResult = {
  __typename?: 'CavernsMobDeathResult';
  death_tile_loot_events?: Maybe<Array<CavernsMobDeathTileLoot>>;
  num_remaining_mobs?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CavernsMobDeathTileLoot = {
  __typename?: 'CavernsMobDeathTileLoot';
  deathTileId: Scalars['String']['output'];
  death_tile_loot: Scalars['JSON']['output'];
};

export type CavernsReturnToSurfaceResult = {
  __typename?: 'CavernsReturnToSurfaceResult';
  before_battle?: Maybe<Scalars['JSON']['output']>;
  currency1?: Maybe<Scalars['Int']['output']>;
  currency2?: Maybe<Scalars['Int']['output']>;
  game_submode: Scalars['String']['output'];
  goldGains?: Maybe<Scalars['Int']['output']>;
  hero_roster?: Maybe<Scalars['JSON']['output']>;
  inventory?: Maybe<Scalars['JSON']['output']>;
  items_picked_up?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  living_hero_handles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pdGains?: Maybe<Scalars['Int']['output']>;
  xpGains?: Maybe<Scalars['JSON']['output']>;
};

export type CavernsTravelResult = {
  __typename?: 'CavernsTravelResult';
  all_units_array: Array<Scalars['JSON']['output']>;
  caverns_data?: Maybe<Scalars['JSON']['output']>;
  gold: Scalars['Int']['output'];
  initial_mobs: Array<Scalars['JSON']['output']>;
  items: Array<Scalars['JSON']['output']>;
  new_caverns_level: Scalars['Int']['output'];
  new_room: Scalars['JSON']['output'];
  pd: Scalars['Int']['output'];
};

export type CavernsUpdateUnitsResult = {
  __typename?: 'CavernsUpdateUnitsResult';
  success: Scalars['Boolean']['output'];
};

export type CopyHeroBuildResult = {
  __typename?: 'CopyHeroBuildResult';
  heroBuilds: Array<Scalars['JSON']['output']>;
  heroHandle: Scalars['String']['output'];
};

export type CreateInnBattleResult = {
  __typename?: 'CreateInnBattleResult';
  battle_id: Scalars['String']['output'];
};

export type DiscardCavernsLootItemResult = {
  __typename?: 'DiscardCavernsLootItemResult';
  item_id: Scalars['String']['output'];
};

export type EquipItemResult = {
  __typename?: 'EquipItemResult';
  heroHandle: Scalars['String']['output'];
  target_hero_builds: Array<Scalars['JSON']['output']>;
};

export type InitNewCavernsMapResult = {
  __typename?: 'InitNewCavernsMapResult';
  currency2?: Maybe<Scalars['Int']['output']>;
  game_submode: Scalars['String']['output'];
  spawned_mobs: Array<Maybe<Scalars['JSON']['output']>>;
  startingLevel: Scalars['Int']['output'];
  startingRoom: Scalars['JSON']['output'];
  white_units: Array<Maybe<Scalars['JSON']['output']>>;
};

export type ItemLocationInput = {
  bag_index?: InputMaybe<Scalars['Int']['input']>;
  bag_item_index?: InputMaybe<Scalars['Int']['input']>;
  bag_slot_index?: InputMaybe<Scalars['Int']['input']>;
  hero_build_id?: InputMaybe<Scalars['String']['input']>;
  hero_handle?: InputMaybe<Scalars['String']['input']>;
  location: Scalars['String']['input'];
  slot?: InputMaybe<Scalars['String']['input']>;
  slot_hand?: InputMaybe<Scalars['String']['input']>;
};

export type ItemMoveResult = {
  __typename?: 'ItemMoveResult';
  heroRoster?: Maybe<Scalars['JSON']['output']>;
  inventory?: Maybe<Scalars['JSON']['output']>;
};

export type KongPurchasesResult = {
  __typename?: 'KongPurchasesResult';
  currency1: Scalars['Int']['output'];
  pdAmount: Scalars['Int']['output'];
};

export type LootCavernsTileResult = {
  __typename?: 'LootCavernsTileResult';
  gold: Scalars['Int']['output'];
  items: Array<Maybe<Scalars['JSON']['output']>>;
  pd: Scalars['Int']['output'];
  tile_looted_ids: Array<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  cavernsMobDeath?: Maybe<CavernsMobDeathResult>;
  cavernsReturnToSurface?: Maybe<CavernsReturnToSurfaceResult>;
  cavernsTravel?: Maybe<CavernsTravelResult>;
  cavernsUpdateUnits?: Maybe<CavernsUpdateUnitsResult>;
  claimKongPurchases: KongPurchasesResult;
  copyHeroBuild?: Maybe<CopyHeroBuildResult>;
  createInnBattle?: Maybe<CreateInnBattleResult>;
  createStripePaymentIntent: StripePaymentResult;
  discardCavernsLootItem?: Maybe<DiscardCavernsLootItemResult>;
  downgradeAbility?: Maybe<AbilityChangeResult>;
  downgradeAttribute?: Maybe<AttributeChangeResult>;
  equipAbility?: Maybe<AbilityChangeResult>;
  equipBagToGlobalBagSlot?: Maybe<ItemMoveResult>;
  equipBagToHeroBagSlot?: Maybe<ItemMoveResult>;
  equipItem?: Maybe<EquipItemResult>;
  initNewCavernsMap?: Maybe<InitNewCavernsMapResult>;
  initSteamPurchase: SteamInitResult;
  lootCavernsTile?: Maybe<LootCavernsTileResult>;
  moveAiRoleToIndex?: Maybe<AbilityChangeResult>;
  newsletterSignup: NewsletterSignupResult;
  newsletterUnsubscribe: NewsletterUnsubscribeResult;
  placeItemInGlobalInventory?: Maybe<ItemMoveResult>;
  placeItemInHeroInventory?: Maybe<ItemMoveResult>;
  processYandexPurchase: YandexPurchaseResult;
  purchaseShopItem?: Maybe<PurchaseShopItemResult>;
  resetAbilities?: Maybe<AbilityChangeResult>;
  resetAttributes?: Maybe<AttributeChangeResult>;
  setPortalLevelToCurrentDepth?: Maybe<SetPortalLevelToCurrentDepthResult>;
  spawnCavernsMob?: Maybe<SpawnCavernsMobResult>;
  startInnBattle?: Maybe<StartInnBattleResult>;
  steamPurchasePopupClosed: SteamPurchaseResult;
  unequipAbility?: Maybe<AbilityChangeResult>;
  unequipItem?: Maybe<EquipItemResult>;
  upgradeAbility?: Maybe<AbilityChangeResult>;
  upgradeAttribute?: Maybe<AttributeChangeResult>;
  useHeroXpBoost?: Maybe<UseHeroXpBoostResult>;
};


export type MutationCavernsMobDeathArgs = {
  game_submode: Scalars['String']['input'];
  mob_deaths: Array<CavernsMobDeathEventInput>;
  playerId: Scalars['String']['input'];
};


export type MutationCavernsReturnToSurfaceArgs = {
  game_submode: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationCavernsTravelArgs = {
  direction: Scalars['String']['input'];
  game_submode: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
  survivingWhiteUnits: Array<Scalars['JSON']['input']>;
};


export type MutationCavernsUpdateUnitsArgs = {
  allTiles?: InputMaybe<Scalars['JSON']['input']>;
  allUnits: Scalars['JSON']['input'];
  game_submode: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationClaimKongPurchasesArgs = {
  kongAuthToken: Scalars['String']['input'];
  kongUserId: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationCopyHeroBuildArgs = {
  heroBuildId: Scalars['String']['input'];
  heroHandle: Scalars['String']['input'];
  newBuildName: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationCreateInnBattleArgs = {
  attackLoadout: Scalars['JSON']['input'];
  gameSubmode: Scalars['String']['input'];
  opponentId: Scalars['String']['input'];
  opponentRank: Scalars['Int']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationCreateStripePaymentIntentArgs = {
  paymentMethodId: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
  purchaseSelectionId: Scalars['String']['input'];
};


export type MutationDiscardCavernsLootItemArgs = {
  game_submode: Scalars['String']['input'];
  item_id: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationDowngradeAbilityArgs = {
  abilityHandle: Scalars['String']['input'];
  heroBuildId: Scalars['String']['input'];
  heroHandle: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationDowngradeAttributeArgs = {
  attributeHandle: Scalars['String']['input'];
  heroBuildId: Scalars['String']['input'];
  heroHandle: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationEquipAbilityArgs = {
  abilityHandle: Scalars['String']['input'];
  heroBuildId: Scalars['String']['input'];
  heroHandle: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationEquipBagToGlobalBagSlotArgs = {
  from: ItemLocationInput;
  playerId: Scalars['String']['input'];
  to: ItemLocationInput;
};


export type MutationEquipBagToHeroBagSlotArgs = {
  from: ItemLocationInput;
  playerId: Scalars['String']['input'];
  to: ItemLocationInput;
};


export type MutationEquipItemArgs = {
  from: ItemLocationInput;
  itemId: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
  to: ItemLocationInput;
};


export type MutationInitNewCavernsMapArgs = {
  gameSubmode: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
  startingLevel: Scalars['Int']['input'];
};


export type MutationInitSteamPurchaseArgs = {
  description: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
  purchaseSelectionId: Scalars['String']['input'];
  steamId64: Scalars['String']['input'];
};


export type MutationLootCavernsTileArgs = {
  game_submode: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
  tile_ids: Array<Scalars['String']['input']>;
};


export type MutationMoveAiRoleToIndexArgs = {
  aiTreeTag: Scalars['String']['input'];
  heroBuildId: Scalars['String']['input'];
  heroHandle: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
  targetIndex: Scalars['Int']['input'];
};


export type MutationNewsletterSignupArgs = {
  email: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationNewsletterUnsubscribeArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['String']['input'];
};


export type MutationPlaceItemInGlobalInventoryArgs = {
  from: ItemLocationInput;
  itemId: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
  to: ItemLocationInput;
};


export type MutationPlaceItemInHeroInventoryArgs = {
  from: ItemLocationInput;
  itemId: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
  to: ItemLocationInput;
};


export type MutationProcessYandexPurchaseArgs = {
  platform: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
  purchase: Scalars['JSON']['input'];
};


export type MutationPurchaseShopItemArgs = {
  itemId: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationResetAbilitiesArgs = {
  heroBuildId: Scalars['String']['input'];
  heroHandle: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationResetAttributesArgs = {
  heroBuildId: Scalars['String']['input'];
  heroHandle: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationSetPortalLevelToCurrentDepthArgs = {
  game_submode: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationSpawnCavernsMobArgs = {
  game_submode: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
  spawnX: Scalars['Int']['input'];
  spawnY: Scalars['Int']['input'];
};


export type MutationStartInnBattleArgs = {
  battleId: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationSteamPurchasePopupClosedArgs = {
  orderid: Scalars['String']['input'];
  pdAmount: Scalars['Int']['input'];
  platform: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
  transid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnequipAbilityArgs = {
  abilityHandle: Scalars['String']['input'];
  heroBuildId: Scalars['String']['input'];
  heroHandle: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationUnequipItemArgs = {
  from: ItemLocationInput;
  itemId: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationUpgradeAbilityArgs = {
  abilityHandle: Scalars['String']['input'];
  heroBuildId: Scalars['String']['input'];
  heroHandle: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationUpgradeAttributeArgs = {
  attributeHandle: Scalars['String']['input'];
  heroBuildId: Scalars['String']['input'];
  heroHandle: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type MutationUseHeroXpBoostArgs = {
  heroHandle: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
  potionId: Scalars['String']['input'];
};

export type NewsletterSignupResult = {
  __typename?: 'NewsletterSignupResult';
  currency1?: Maybe<Scalars['Int']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type NewsletterUnsubscribeResult = {
  __typename?: 'NewsletterUnsubscribeResult';
  detail?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum PaymentStatus {
  CardDeclined = 'CARD_DECLINED',
  Error = 'ERROR',
  RequiresAction = 'REQUIRES_ACTION',
  Succeeded = 'SUCCEEDED'
}

export type PlayerInnSubmodeStateResult = {
  __typename?: 'PlayerInnSubmodeStateResult';
  didNewTourneyPlacement: Scalars['Boolean']['output'];
  playerInnSubmodeState: Scalars['JSON']['output'];
  tourneyInstance: Scalars['JSON']['output'];
};

export type PurchaseShopItemResult = {
  __typename?: 'PurchaseShopItemResult';
  currency1?: Maybe<Scalars['Int']['output']>;
  currency2?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  inventory?: Maybe<Scalars['JSON']['output']>;
  last_restock?: Maybe<Scalars['Float']['output']>;
  shopInventory?: Maybe<Array<Scalars['JSON']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  cavernsData?: Maybe<Scalars['JSON']['output']>;
  getPlayerInnSubmodeState: PlayerInnSubmodeStateResult;
  getRandomInnOpponents: RandomInnOpponentsResult;
  getShopInventory?: Maybe<ShopInventoryResult>;
};


export type QueryCavernsDataArgs = {
  playerId: Scalars['String']['input'];
};


export type QueryGetPlayerInnSubmodeStateArgs = {
  gameSubmode: Scalars['String']['input'];
  playerId: Scalars['String']['input'];
};


export type QueryGetRandomInnOpponentsArgs = {
  gameSubmode: Scalars['String']['input'];
  numOpponents?: InputMaybe<Scalars['Int']['input']>;
  playerId: Scalars['String']['input'];
};


export type QueryGetShopInventoryArgs = {
  playerId: Scalars['String']['input'];
};

export type RandomInnOpponentsResult = {
  __typename?: 'RandomInnOpponentsResult';
  gameSubmode: Scalars['String']['output'];
  innOpponents: Scalars['JSON']['output'];
};

export type SetPortalLevelToCurrentDepthResult = {
  __typename?: 'SetPortalLevelToCurrentDepthResult';
  caverns_data?: Maybe<Scalars['JSON']['output']>;
  game_submode: Scalars['String']['output'];
  new_portal_level: Scalars['Int']['output'];
};

export type ShopInventoryResult = {
  __typename?: 'ShopInventoryResult';
  last_restock: Scalars['Float']['output'];
  shopInventory: Array<Scalars['JSON']['output']>;
};

export type SpawnCavernsMobResult = {
  __typename?: 'SpawnCavernsMobResult';
  mob?: Maybe<Scalars['JSON']['output']>;
};

export type StartInnBattleResult = {
  __typename?: 'StartInnBattleResult';
  battle_id: Scalars['String']['output'];
};

export type SteamInitResult = {
  __typename?: 'SteamInitResult';
  orderid: Scalars['String']['output'];
  pdAmount: Scalars['Int']['output'];
  steamurl: Scalars['String']['output'];
  transid?: Maybe<Scalars['String']['output']>;
};

export type SteamPurchaseResult = {
  __typename?: 'SteamPurchaseResult';
  completed: Scalars['Boolean']['output'];
  currency1?: Maybe<Scalars['Int']['output']>;
  pdAmount?: Maybe<Scalars['Int']['output']>;
};

export type StripePaymentResult = {
  __typename?: 'StripePaymentResult';
  chargeAmount?: Maybe<Scalars['Int']['output']>;
  currency1?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  purchaseSelectionId?: Maybe<Scalars['String']['output']>;
  status: PaymentStatus;
};

export type UseHeroXpBoostResult = {
  __typename?: 'UseHeroXpBoostResult';
  hero_roster?: Maybe<Scalars['JSON']['output']>;
  inventory?: Maybe<Scalars['JSON']['output']>;
};

export type YandexPurchaseResult = {
  __typename?: 'YandexPurchaseResult';
  currency1: Scalars['Int']['output'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;





/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AbilityChangeResult: ResolverTypeWrapper<AbilityChangeResult>;
  AttributeChangeResult: ResolverTypeWrapper<AttributeChangeResult>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  CavernsMobDeathEventInput: CavernsMobDeathEventInput;
  CavernsMobDeathResult: ResolverTypeWrapper<CavernsMobDeathResult>;
  CavernsMobDeathTileLoot: ResolverTypeWrapper<CavernsMobDeathTileLoot>;
  CavernsReturnToSurfaceResult: ResolverTypeWrapper<CavernsReturnToSurfaceResult>;
  CavernsTravelResult: ResolverTypeWrapper<CavernsTravelResult>;
  CavernsUpdateUnitsResult: ResolverTypeWrapper<CavernsUpdateUnitsResult>;
  CopyHeroBuildResult: ResolverTypeWrapper<CopyHeroBuildResult>;
  CreateInnBattleResult: ResolverTypeWrapper<CreateInnBattleResult>;
  DiscardCavernsLootItemResult: ResolverTypeWrapper<DiscardCavernsLootItemResult>;
  EquipItemResult: ResolverTypeWrapper<EquipItemResult>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  InitNewCavernsMapResult: ResolverTypeWrapper<InitNewCavernsMapResult>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  ItemLocationInput: ItemLocationInput;
  ItemMoveResult: ResolverTypeWrapper<ItemMoveResult>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  KongPurchasesResult: ResolverTypeWrapper<KongPurchasesResult>;
  LootCavernsTileResult: ResolverTypeWrapper<LootCavernsTileResult>;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  NewsletterSignupResult: ResolverTypeWrapper<NewsletterSignupResult>;
  NewsletterUnsubscribeResult: ResolverTypeWrapper<NewsletterUnsubscribeResult>;
  PaymentStatus: PaymentStatus;
  PlayerInnSubmodeStateResult: ResolverTypeWrapper<PlayerInnSubmodeStateResult>;
  PurchaseShopItemResult: ResolverTypeWrapper<PurchaseShopItemResult>;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  RandomInnOpponentsResult: ResolverTypeWrapper<RandomInnOpponentsResult>;
  SetPortalLevelToCurrentDepthResult: ResolverTypeWrapper<SetPortalLevelToCurrentDepthResult>;
  ShopInventoryResult: ResolverTypeWrapper<ShopInventoryResult>;
  SpawnCavernsMobResult: ResolverTypeWrapper<SpawnCavernsMobResult>;
  StartInnBattleResult: ResolverTypeWrapper<StartInnBattleResult>;
  SteamInitResult: ResolverTypeWrapper<SteamInitResult>;
  SteamPurchaseResult: ResolverTypeWrapper<SteamPurchaseResult>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  StripePaymentResult: ResolverTypeWrapper<StripePaymentResult>;
  UseHeroXpBoostResult: ResolverTypeWrapper<UseHeroXpBoostResult>;
  YandexPurchaseResult: ResolverTypeWrapper<YandexPurchaseResult>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AbilityChangeResult: AbilityChangeResult;
  AttributeChangeResult: AttributeChangeResult;
  Boolean: Scalars['Boolean']['output'];
  CavernsMobDeathEventInput: CavernsMobDeathEventInput;
  CavernsMobDeathResult: CavernsMobDeathResult;
  CavernsMobDeathTileLoot: CavernsMobDeathTileLoot;
  CavernsReturnToSurfaceResult: CavernsReturnToSurfaceResult;
  CavernsTravelResult: CavernsTravelResult;
  CavernsUpdateUnitsResult: CavernsUpdateUnitsResult;
  CopyHeroBuildResult: CopyHeroBuildResult;
  CreateInnBattleResult: CreateInnBattleResult;
  DiscardCavernsLootItemResult: DiscardCavernsLootItemResult;
  EquipItemResult: EquipItemResult;
  Float: Scalars['Float']['output'];
  InitNewCavernsMapResult: InitNewCavernsMapResult;
  Int: Scalars['Int']['output'];
  ItemLocationInput: ItemLocationInput;
  ItemMoveResult: ItemMoveResult;
  JSON: Scalars['JSON']['output'];
  KongPurchasesResult: KongPurchasesResult;
  LootCavernsTileResult: LootCavernsTileResult;
  Mutation: Record<PropertyKey, never>;
  NewsletterSignupResult: NewsletterSignupResult;
  NewsletterUnsubscribeResult: NewsletterUnsubscribeResult;
  PlayerInnSubmodeStateResult: PlayerInnSubmodeStateResult;
  PurchaseShopItemResult: PurchaseShopItemResult;
  Query: Record<PropertyKey, never>;
  RandomInnOpponentsResult: RandomInnOpponentsResult;
  SetPortalLevelToCurrentDepthResult: SetPortalLevelToCurrentDepthResult;
  ShopInventoryResult: ShopInventoryResult;
  SpawnCavernsMobResult: SpawnCavernsMobResult;
  StartInnBattleResult: StartInnBattleResult;
  SteamInitResult: SteamInitResult;
  SteamPurchaseResult: SteamPurchaseResult;
  String: Scalars['String']['output'];
  StripePaymentResult: StripePaymentResult;
  UseHeroXpBoostResult: UseHeroXpBoostResult;
  YandexPurchaseResult: YandexPurchaseResult;
};

export type AbilityChangeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AbilityChangeResult'] = ResolversParentTypes['AbilityChangeResult']> = {
  heroBuild?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  heroHandle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AttributeChangeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AttributeChangeResult'] = ResolversParentTypes['AttributeChangeResult']> = {
  heroBuild?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  heroHandle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CavernsMobDeathResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CavernsMobDeathResult'] = ResolversParentTypes['CavernsMobDeathResult']> = {
  death_tile_loot_events?: Resolver<Maybe<Array<ResolversTypes['CavernsMobDeathTileLoot']>>, ParentType, ContextType>;
  num_remaining_mobs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type CavernsMobDeathTileLootResolvers<ContextType = any, ParentType extends ResolversParentTypes['CavernsMobDeathTileLoot'] = ResolversParentTypes['CavernsMobDeathTileLoot']> = {
  deathTileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  death_tile_loot?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
};

export type CavernsReturnToSurfaceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CavernsReturnToSurfaceResult'] = ResolversParentTypes['CavernsReturnToSurfaceResult']> = {
  before_battle?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  currency1?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currency2?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  game_submode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  goldGains?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hero_roster?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  inventory?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  items_picked_up?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  living_hero_handles?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  pdGains?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  xpGains?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
};

export type CavernsTravelResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CavernsTravelResult'] = ResolversParentTypes['CavernsTravelResult']> = {
  all_units_array?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
  caverns_data?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  gold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  initial_mobs?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
  new_caverns_level?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  new_room?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  pd?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type CavernsUpdateUnitsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CavernsUpdateUnitsResult'] = ResolversParentTypes['CavernsUpdateUnitsResult']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type CopyHeroBuildResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CopyHeroBuildResult'] = ResolversParentTypes['CopyHeroBuildResult']> = {
  heroBuilds?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
  heroHandle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CreateInnBattleResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateInnBattleResult'] = ResolversParentTypes['CreateInnBattleResult']> = {
  battle_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DiscardCavernsLootItemResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiscardCavernsLootItemResult'] = ResolversParentTypes['DiscardCavernsLootItemResult']> = {
  item_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EquipItemResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipItemResult'] = ResolversParentTypes['EquipItemResult']> = {
  heroHandle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  target_hero_builds?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
};

export type InitNewCavernsMapResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['InitNewCavernsMapResult'] = ResolversParentTypes['InitNewCavernsMapResult']> = {
  currency2?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  game_submode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spawned_mobs?: Resolver<Array<Maybe<ResolversTypes['JSON']>>, ParentType, ContextType>;
  startingLevel?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startingRoom?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  white_units?: Resolver<Array<Maybe<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type ItemMoveResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ItemMoveResult'] = ResolversParentTypes['ItemMoveResult']> = {
  heroRoster?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  inventory?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type KongPurchasesResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['KongPurchasesResult'] = ResolversParentTypes['KongPurchasesResult']> = {
  currency1?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pdAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type LootCavernsTileResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LootCavernsTileResult'] = ResolversParentTypes['LootCavernsTileResult']> = {
  gold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  items?: Resolver<Array<Maybe<ResolversTypes['JSON']>>, ParentType, ContextType>;
  pd?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  tile_looted_ids?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  cavernsMobDeath?: Resolver<Maybe<ResolversTypes['CavernsMobDeathResult']>, ParentType, ContextType, RequireFields<MutationCavernsMobDeathArgs, 'game_submode' | 'mob_deaths' | 'playerId'>>;
  cavernsReturnToSurface?: Resolver<Maybe<ResolversTypes['CavernsReturnToSurfaceResult']>, ParentType, ContextType, RequireFields<MutationCavernsReturnToSurfaceArgs, 'game_submode' | 'playerId'>>;
  cavernsTravel?: Resolver<Maybe<ResolversTypes['CavernsTravelResult']>, ParentType, ContextType, RequireFields<MutationCavernsTravelArgs, 'direction' | 'game_submode' | 'playerId' | 'survivingWhiteUnits'>>;
  cavernsUpdateUnits?: Resolver<Maybe<ResolversTypes['CavernsUpdateUnitsResult']>, ParentType, ContextType, RequireFields<MutationCavernsUpdateUnitsArgs, 'allUnits' | 'game_submode' | 'playerId'>>;
  claimKongPurchases?: Resolver<ResolversTypes['KongPurchasesResult'], ParentType, ContextType, RequireFields<MutationClaimKongPurchasesArgs, 'kongAuthToken' | 'kongUserId' | 'platform' | 'playerId'>>;
  copyHeroBuild?: Resolver<Maybe<ResolversTypes['CopyHeroBuildResult']>, ParentType, ContextType, RequireFields<MutationCopyHeroBuildArgs, 'heroBuildId' | 'heroHandle' | 'newBuildName' | 'playerId'>>;
  createInnBattle?: Resolver<Maybe<ResolversTypes['CreateInnBattleResult']>, ParentType, ContextType, RequireFields<MutationCreateInnBattleArgs, 'attackLoadout' | 'gameSubmode' | 'opponentId' | 'opponentRank' | 'playerId'>>;
  createStripePaymentIntent?: Resolver<ResolversTypes['StripePaymentResult'], ParentType, ContextType, RequireFields<MutationCreateStripePaymentIntentArgs, 'paymentMethodId' | 'platform' | 'playerId' | 'purchaseSelectionId'>>;
  discardCavernsLootItem?: Resolver<Maybe<ResolversTypes['DiscardCavernsLootItemResult']>, ParentType, ContextType, RequireFields<MutationDiscardCavernsLootItemArgs, 'game_submode' | 'item_id' | 'playerId'>>;
  downgradeAbility?: Resolver<Maybe<ResolversTypes['AbilityChangeResult']>, ParentType, ContextType, RequireFields<MutationDowngradeAbilityArgs, 'abilityHandle' | 'heroBuildId' | 'heroHandle' | 'playerId'>>;
  downgradeAttribute?: Resolver<Maybe<ResolversTypes['AttributeChangeResult']>, ParentType, ContextType, RequireFields<MutationDowngradeAttributeArgs, 'attributeHandle' | 'heroBuildId' | 'heroHandle' | 'playerId'>>;
  equipAbility?: Resolver<Maybe<ResolversTypes['AbilityChangeResult']>, ParentType, ContextType, RequireFields<MutationEquipAbilityArgs, 'abilityHandle' | 'heroBuildId' | 'heroHandle' | 'playerId'>>;
  equipBagToGlobalBagSlot?: Resolver<Maybe<ResolversTypes['ItemMoveResult']>, ParentType, ContextType, RequireFields<MutationEquipBagToGlobalBagSlotArgs, 'from' | 'playerId' | 'to'>>;
  equipBagToHeroBagSlot?: Resolver<Maybe<ResolversTypes['ItemMoveResult']>, ParentType, ContextType, RequireFields<MutationEquipBagToHeroBagSlotArgs, 'from' | 'playerId' | 'to'>>;
  equipItem?: Resolver<Maybe<ResolversTypes['EquipItemResult']>, ParentType, ContextType, RequireFields<MutationEquipItemArgs, 'from' | 'itemId' | 'playerId' | 'to'>>;
  initNewCavernsMap?: Resolver<Maybe<ResolversTypes['InitNewCavernsMapResult']>, ParentType, ContextType, RequireFields<MutationInitNewCavernsMapArgs, 'gameSubmode' | 'playerId' | 'startingLevel'>>;
  initSteamPurchase?: Resolver<ResolversTypes['SteamInitResult'], ParentType, ContextType, RequireFields<MutationInitSteamPurchaseArgs, 'description' | 'platform' | 'playerId' | 'purchaseSelectionId' | 'steamId64'>>;
  lootCavernsTile?: Resolver<Maybe<ResolversTypes['LootCavernsTileResult']>, ParentType, ContextType, RequireFields<MutationLootCavernsTileArgs, 'game_submode' | 'playerId' | 'tile_ids'>>;
  moveAiRoleToIndex?: Resolver<Maybe<ResolversTypes['AbilityChangeResult']>, ParentType, ContextType, RequireFields<MutationMoveAiRoleToIndexArgs, 'aiTreeTag' | 'heroBuildId' | 'heroHandle' | 'playerId' | 'targetIndex'>>;
  newsletterSignup?: Resolver<ResolversTypes['NewsletterSignupResult'], ParentType, ContextType, RequireFields<MutationNewsletterSignupArgs, 'email' | 'playerId'>>;
  newsletterUnsubscribe?: Resolver<ResolversTypes['NewsletterUnsubscribeResult'], ParentType, ContextType, RequireFields<MutationNewsletterUnsubscribeArgs, 'playerId'>>;
  placeItemInGlobalInventory?: Resolver<Maybe<ResolversTypes['ItemMoveResult']>, ParentType, ContextType, RequireFields<MutationPlaceItemInGlobalInventoryArgs, 'from' | 'itemId' | 'playerId' | 'to'>>;
  placeItemInHeroInventory?: Resolver<Maybe<ResolversTypes['ItemMoveResult']>, ParentType, ContextType, RequireFields<MutationPlaceItemInHeroInventoryArgs, 'from' | 'itemId' | 'playerId' | 'to'>>;
  processYandexPurchase?: Resolver<ResolversTypes['YandexPurchaseResult'], ParentType, ContextType, RequireFields<MutationProcessYandexPurchaseArgs, 'platform' | 'playerId' | 'purchase'>>;
  purchaseShopItem?: Resolver<Maybe<ResolversTypes['PurchaseShopItemResult']>, ParentType, ContextType, RequireFields<MutationPurchaseShopItemArgs, 'itemId' | 'playerId'>>;
  resetAbilities?: Resolver<Maybe<ResolversTypes['AbilityChangeResult']>, ParentType, ContextType, RequireFields<MutationResetAbilitiesArgs, 'heroBuildId' | 'heroHandle' | 'playerId'>>;
  resetAttributes?: Resolver<Maybe<ResolversTypes['AttributeChangeResult']>, ParentType, ContextType, RequireFields<MutationResetAttributesArgs, 'heroBuildId' | 'heroHandle' | 'playerId'>>;
  setPortalLevelToCurrentDepth?: Resolver<Maybe<ResolversTypes['SetPortalLevelToCurrentDepthResult']>, ParentType, ContextType, RequireFields<MutationSetPortalLevelToCurrentDepthArgs, 'game_submode' | 'playerId'>>;
  spawnCavernsMob?: Resolver<Maybe<ResolversTypes['SpawnCavernsMobResult']>, ParentType, ContextType, RequireFields<MutationSpawnCavernsMobArgs, 'game_submode' | 'playerId' | 'spawnX' | 'spawnY'>>;
  startInnBattle?: Resolver<Maybe<ResolversTypes['StartInnBattleResult']>, ParentType, ContextType, RequireFields<MutationStartInnBattleArgs, 'battleId' | 'playerId'>>;
  steamPurchasePopupClosed?: Resolver<ResolversTypes['SteamPurchaseResult'], ParentType, ContextType, RequireFields<MutationSteamPurchasePopupClosedArgs, 'orderid' | 'pdAmount' | 'platform' | 'playerId'>>;
  unequipAbility?: Resolver<Maybe<ResolversTypes['AbilityChangeResult']>, ParentType, ContextType, RequireFields<MutationUnequipAbilityArgs, 'abilityHandle' | 'heroBuildId' | 'heroHandle' | 'playerId'>>;
  unequipItem?: Resolver<Maybe<ResolversTypes['EquipItemResult']>, ParentType, ContextType, RequireFields<MutationUnequipItemArgs, 'from' | 'itemId' | 'playerId'>>;
  upgradeAbility?: Resolver<Maybe<ResolversTypes['AbilityChangeResult']>, ParentType, ContextType, RequireFields<MutationUpgradeAbilityArgs, 'abilityHandle' | 'heroBuildId' | 'heroHandle' | 'playerId'>>;
  upgradeAttribute?: Resolver<Maybe<ResolversTypes['AttributeChangeResult']>, ParentType, ContextType, RequireFields<MutationUpgradeAttributeArgs, 'attributeHandle' | 'heroBuildId' | 'heroHandle' | 'playerId'>>;
  useHeroXpBoost?: Resolver<Maybe<ResolversTypes['UseHeroXpBoostResult']>, ParentType, ContextType, RequireFields<MutationUseHeroXpBoostArgs, 'heroHandle' | 'playerId' | 'potionId'>>;
};

export type NewsletterSignupResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewsletterSignupResult'] = ResolversParentTypes['NewsletterSignupResult']> = {
  currency1?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  detail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type NewsletterUnsubscribeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['NewsletterUnsubscribeResult'] = ResolversParentTypes['NewsletterUnsubscribeResult']> = {
  detail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ok?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type PlayerInnSubmodeStateResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlayerInnSubmodeStateResult'] = ResolversParentTypes['PlayerInnSubmodeStateResult']> = {
  didNewTourneyPlacement?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  playerInnSubmodeState?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  tourneyInstance?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
};

export type PurchaseShopItemResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseShopItemResult'] = ResolversParentTypes['PurchaseShopItemResult']> = {
  currency1?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currency2?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inventory?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  last_restock?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  shopInventory?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  cavernsData?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<QueryCavernsDataArgs, 'playerId'>>;
  getPlayerInnSubmodeState?: Resolver<ResolversTypes['PlayerInnSubmodeStateResult'], ParentType, ContextType, RequireFields<QueryGetPlayerInnSubmodeStateArgs, 'gameSubmode' | 'playerId'>>;
  getRandomInnOpponents?: Resolver<ResolversTypes['RandomInnOpponentsResult'], ParentType, ContextType, RequireFields<QueryGetRandomInnOpponentsArgs, 'gameSubmode' | 'playerId'>>;
  getShopInventory?: Resolver<Maybe<ResolversTypes['ShopInventoryResult']>, ParentType, ContextType, RequireFields<QueryGetShopInventoryArgs, 'playerId'>>;
};

export type RandomInnOpponentsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RandomInnOpponentsResult'] = ResolversParentTypes['RandomInnOpponentsResult']> = {
  gameSubmode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  innOpponents?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
};

export type SetPortalLevelToCurrentDepthResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetPortalLevelToCurrentDepthResult'] = ResolversParentTypes['SetPortalLevelToCurrentDepthResult']> = {
  caverns_data?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  game_submode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  new_portal_level?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ShopInventoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShopInventoryResult'] = ResolversParentTypes['ShopInventoryResult']> = {
  last_restock?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  shopInventory?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
};

export type SpawnCavernsMobResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SpawnCavernsMobResult'] = ResolversParentTypes['SpawnCavernsMobResult']> = {
  mob?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
};

export type StartInnBattleResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['StartInnBattleResult'] = ResolversParentTypes['StartInnBattleResult']> = {
  battle_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SteamInitResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SteamInitResult'] = ResolversParentTypes['SteamInitResult']> = {
  orderid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pdAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  steamurl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SteamPurchaseResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SteamPurchaseResult'] = ResolversParentTypes['SteamPurchaseResult']> = {
  completed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  currency1?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pdAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type StripePaymentResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['StripePaymentResult'] = ResolversParentTypes['StripePaymentResult']> = {
  chargeAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  currency1?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  purchaseSelectionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PaymentStatus'], ParentType, ContextType>;
};

export type UseHeroXpBoostResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UseHeroXpBoostResult'] = ResolversParentTypes['UseHeroXpBoostResult']> = {
  hero_roster?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  inventory?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
};

export type YandexPurchaseResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['YandexPurchaseResult'] = ResolversParentTypes['YandexPurchaseResult']> = {
  currency1?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AbilityChangeResult?: AbilityChangeResultResolvers<ContextType>;
  AttributeChangeResult?: AttributeChangeResultResolvers<ContextType>;
  CavernsMobDeathResult?: CavernsMobDeathResultResolvers<ContextType>;
  CavernsMobDeathTileLoot?: CavernsMobDeathTileLootResolvers<ContextType>;
  CavernsReturnToSurfaceResult?: CavernsReturnToSurfaceResultResolvers<ContextType>;
  CavernsTravelResult?: CavernsTravelResultResolvers<ContextType>;
  CavernsUpdateUnitsResult?: CavernsUpdateUnitsResultResolvers<ContextType>;
  CopyHeroBuildResult?: CopyHeroBuildResultResolvers<ContextType>;
  CreateInnBattleResult?: CreateInnBattleResultResolvers<ContextType>;
  DiscardCavernsLootItemResult?: DiscardCavernsLootItemResultResolvers<ContextType>;
  EquipItemResult?: EquipItemResultResolvers<ContextType>;
  InitNewCavernsMapResult?: InitNewCavernsMapResultResolvers<ContextType>;
  ItemMoveResult?: ItemMoveResultResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  KongPurchasesResult?: KongPurchasesResultResolvers<ContextType>;
  LootCavernsTileResult?: LootCavernsTileResultResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NewsletterSignupResult?: NewsletterSignupResultResolvers<ContextType>;
  NewsletterUnsubscribeResult?: NewsletterUnsubscribeResultResolvers<ContextType>;
  PlayerInnSubmodeStateResult?: PlayerInnSubmodeStateResultResolvers<ContextType>;
  PurchaseShopItemResult?: PurchaseShopItemResultResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RandomInnOpponentsResult?: RandomInnOpponentsResultResolvers<ContextType>;
  SetPortalLevelToCurrentDepthResult?: SetPortalLevelToCurrentDepthResultResolvers<ContextType>;
  ShopInventoryResult?: ShopInventoryResultResolvers<ContextType>;
  SpawnCavernsMobResult?: SpawnCavernsMobResultResolvers<ContextType>;
  StartInnBattleResult?: StartInnBattleResultResolvers<ContextType>;
  SteamInitResult?: SteamInitResultResolvers<ContextType>;
  SteamPurchaseResult?: SteamPurchaseResultResolvers<ContextType>;
  StripePaymentResult?: StripePaymentResultResolvers<ContextType>;
  UseHeroXpBoostResult?: UseHeroXpBoostResultResolvers<ContextType>;
  YandexPurchaseResult?: YandexPurchaseResultResolvers<ContextType>;
};

